import { Table, TableBody } from "@mui/material";
import { InsertDriveFile as DocumentsIcon } from "@mui/icons-material";
import type {
  VendorProfileDocument,
  VendorProfileFacility,
  VendorProfileVendor,
} from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { AttachmentDisplay } from "../components/AttachmentDisplay";
import { findDocument } from "../utils/documentLookup";

type Props = {
  vendor: VendorProfileVendor | null | undefined;
  primary: VendorProfileFacility;
  documents: VendorProfileDocument[] | undefined;
};

export function VendorDocumentsSection({ vendor, primary, documents }: Props) {
  const vDoc = (type: string) =>
    vendor ? findDocument(documents, "vendor", vendor.id, type) : undefined;
  const fDoc = (type: string) =>
    findDocument(documents, "facility", primary.id, type);
  return (
    <SectionCard icon={<DocumentsIcon fontSize="small" />} title="Documents">
      <Table size="small">
        <TableBody>
          <FieldRow
            label="Vendor Agreement"
            value={<AttachmentDisplay document={vDoc("Vendor_Agreement")} />}
          />
          <FieldRow
            label="Vendor Quotation 1"
            value={<AttachmentDisplay document={fDoc("Quotation_1")} />}
          />
          <FieldRow
            label="Vendor Quotation 2"
            value={<AttachmentDisplay document={fDoc("Quotation_2")} />}
          />
          <FieldRow
            label="Vendor Quotation 3"
            value={<AttachmentDisplay document={fDoc("Quotation_3")} />}
          />
          <FieldRow
            label="Comparative Benchmarking"
            value={<AttachmentDisplay document={fDoc("Comparative_Benchmarking")} />}
          />
          <FieldRow
            label="Quote Justification"
            value={<AttachmentDisplay document={fDoc("Quote_Justification")} />}
          />
          <FieldRow
            label="L1 Justification"
            value={<AttachmentDisplay document={fDoc("L1_Justification")} />}
          />
          {fDoc("Installation_Training_Evidence") && (
            <FieldRow
              label="Installation Training Evidence"
              value={<AttachmentDisplay document={fDoc("Installation_Training_Evidence")} />}
            />
          )}
          {fDoc("Training_Terms_Alignment") && (
            <FieldRow
              label="Training & Terms Alignment"
              value={<AttachmentDisplay document={fDoc("Training_Terms_Alignment")} />}
            />
          )}
          {fDoc("Ops_Site_Visit_Photos") && (
            <FieldRow
              label="Site-Visit Photos"
              value={<AttachmentDisplay document={fDoc("Ops_Site_Visit_Photos")} />}
            />
          )}
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default VendorDocumentsSection;
